"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
const Office_1 = __importDefault(require("./Office"));
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
const EFolderStatus_1 = __importDefault(require("./EFolderStatus"));
const Customer_1 = __importDefault(require("./Customer"));
const Note_1 = __importDefault(require("./Note"));
class OfficeFolder extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.description = null;
        this.archived_description = null;
        this.status = EFolderStatus_1.default.LIVE;
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = OfficeFolder;
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeFolder.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeFolder.prototype, "folder_number", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeFolder.prototype, "name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "description", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "archived_description", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeFolder.prototype, "status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "long_term_archive_status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "long_term_archive_started_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "long_term_archived_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "long_term_archive_last_error", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Office_1.default),
    __metadata("design:type", Office_1.default)
], OfficeFolder.prototype, "office", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Customer_1.default),
    __metadata("design:type", Array)
], OfficeFolder.prototype, "customers", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "deleted_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "deleted_by_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Note_1.default),
    __metadata("design:type", Array)
], OfficeFolder.prototype, "notes", void 0);
